<div class="banner revert-margin-content" [ngClass]="{ 'revert-home-padding-top': revertHomePaddingTop }" *ngIf="instanceBannerUrl">
  <img [src]="instanceBannerUrl" alt="Instance banner">
</div>
